const firebaseConfig = {
    apiKey: "AIzaSyBZebcrQyPCu7JAtdWHNVwtHm1e6ZdRELg",
    authDomain: "crypto-vest.firebaseapp.com",
    projectId: "crypto-vest",
    storageBucket: "crypto-vest.appspot.com",
    messagingSenderId: "998694204650",
    appId: "1:998694204650:web:e1600f8a22e3cec0b59393"
  };
  export default firebaseConfig